/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import React from 'react';
export var COMPONENT_TOP_MARGIN = "var(--ds-space-150, 12px)";
export var Root = function Root(_ref) {
  var forgeDoc = _ref.forgeDoc,
    render = _ref.render;
  var children = forgeDoc.children;
  var isChildVisible = function isChildVisible(type) {
    return !['ModalDialog'].includes(type);
  };
  var nonVisibleChildren = children.filter(function (_ref2) {
    var type = _ref2.type;
    return !isChildVisible(type);
  });
  var visibleChildren = children.filter(function (_ref3) {
    var type = _ref3.type;
    return isChildVisible(type);
  });
  var visibleReactChildren = visibleChildren.map(render);
  return jsx("div", {
    "data-testid": "ui-kit-2-root-element"
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    ,
    css: css({
      display: 'inherit',
      width: 'inherit',
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
      '> *:not(:first-of-type)': {
        marginTop: COMPONENT_TOP_MARGIN,
        width: 'inherit'
      }
    })
  }, React.Children.map(visibleReactChildren, function (child) {
    return jsx("div", null, child);
  }), nonVisibleChildren.map(render));
};